"use client"

import * as React from "react"

import type { DashboardOverviewMode } from "@/features/dashboard/hooks/use-dashboard-page-state"
import type { DashboardData } from "@/features/dashboard/model/dashboard-types"

type DashboardOverviewContextValue = {
  data: DashboardData
  overviewMode: DashboardOverviewMode
}

const DashboardOverviewContext = React.createContext<DashboardOverviewContextValue | null>(null)

export function DashboardOverviewProvider({
  children,
  data,
  overviewMode,
}: {
  children: React.ReactNode
  data: DashboardData
  overviewMode: DashboardOverviewMode
}) {
  const value = React.useMemo(() => ({ data, overviewMode }), [data, overviewMode])
  return <DashboardOverviewContext.Provider value={value}>{children}</DashboardOverviewContext.Provider>
}

export function useDashboardOverview(): DashboardOverviewContextValue {
  const context = React.useContext(DashboardOverviewContext)
  if (!context) {
    throw new Error("useDashboardOverview must be used within DashboardOverviewProvider")
  }
  return context
}
